import { render, staticRenderFns } from "./DiscordEmbed.vue?vue&type=template&id=4c8c4d71&scoped=true&"
import script from "./DiscordEmbed.vue?vue&type=script&lang=js&"
export * from "./DiscordEmbed.vue?vue&type=script&lang=js&"
import style0 from "./DiscordEmbed.vue?vue&type=style&index=0&id=4c8c4d71&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c4d71",
  null
  
)

export default component.exports